import { Link } from 'react-router-dom';
import { AuthNotice } from '../components/AuthSplitLayout.tsx';

export function NotFound() {
  return (
    <AuthNotice
      variant="admin"
      title="Page not found"
      action={
        <span className="flex gap-3">
          <Link to="/admin" className="font-semibold text-brand-primary hover:underline">
            Admin home
          </Link>
          <span className="text-slate-300">·</span>
          <Link to="/c" className="font-semibold text-brand-primary hover:underline">
            Vendor home
          </Link>
        </span>
      }
    >
      <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-400">
        Error 404
      </span>
      We couldn’t find the page you were looking for.
    </AuthNotice>
  );
}
